import styled from "styled-components";
import React, {useEffect, useState} from "react";
import Typography from "@material-ui/core/Typography";
import {Button, TextField} from "@material-ui/core";
import Modal from "@material-ui/core/Modal";
import i18n from "i18next";

const ModalContentStyled = styled.div`
    outline: none;
    padding: 32px;
    position: absolute;
    box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12);
    background-color: #fff;
        top: 50%;
    left: 48%;
    transform: translate(-50%, -48%);
`;
const ConfirmMessageStyled = styled.div`
    margin-top: 25px;
    font-size: 14px;
    color: #241c15;
    font-weight: 500;
`;

function SendingToListModal({isOpenModal, handleClose, action}: any) {

    const [type, setType] = useState('');
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        return () => {
            setLoading(false);
            setType('');
        };
    },[isOpenModal]);

    return (
        <Modal
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            open={isOpenModal}
            onClose={handleClose}
        >
            <ModalContentStyled>
                <Typography variant="h6" id="modal-title">
                    {i18n.t("Let's spread the news.")}
                </Typography>
                <Typography variant="subtitle1" id="simple-modal-description">
                    {i18n.t("You're going to send to the list, you approve?")}
                </Typography>

                <ConfirmMessageStyled>
                    {i18n.t("Type SEND to confirm")}
                </ConfirmMessageStyled>
                <TextField
                    fullWidth
                    margin="normal"
                    variant="outlined"
                    value={type}
                    disabled={loading}
                    onChange={(event: any) => setType(event.target.value)}
                    type='text'
                />
                <div style={{marginTop: '20px'}}>
                    <Button variant="contained" color="primary" disabled={type !== 'SEND' || loading} onClick={() => {
                        setLoading(true);
                        action();
                    }}>
                        {loading && (
                            <img
                                alt='loading'
                                src={process.env.NODE_ENV !== 'production'?'/images/Dual_Ring-1s-200px-blue.svg':'/wp-content/plugins/wp-campaigns/admin/partials/build/images/Dual_Ring-1s-200px-blue.svg'}
                                width="20px"
                                height="20px" style={{marginRight: 10}}/>)}
                        {loading ? i18n.t('Sending ...') : i18n.t('SEND')}
                    </Button>
                    <Button onClick={handleClose}>cancel</Button>
                </div>
            </ModalContentStyled>
        </Modal>
    )
}

export default SendingToListModal;
